import DataSource from "./DataSource";
export default DataSource;


// WEBPACK FOOTER //
// ./src/DataSource/index.js